import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Customers/Table";
import Navbar from "../../Components/Navbar";
import ChangePasswordModal from "../../Components/Admin/ChangePasswordModal";
import { ToastContainer, toast } from "react-toastify";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Customers/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import EditUserModel from "../../Components/Customers/EditUserModel";
import SingleEntry from "../../Components/Customers/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Customers = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [changePasswordModel, setChangePasswordModel] = useState(false);
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("name");
  const [deviceId, setDeviceId] = useState("");

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const [editUser, setEditUser] = useState(false);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  //const isLoadingFetch = "";
  //const error = "";
  //const refetch = "";
  //const isRefetching = "";

  // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("filter", filter);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("filterValue", filterValue);
    body.append("userType", user.userType);
    body.append("type", 5);
    return await axios.post(`${Config.apiUrl}/getusers`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getAppReSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
  };

  const getAppReError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getAppReSuccess,
    onError: getAppReError,
  });

  useEffect(() => {
    getAppRegMutate();
  }, []);

  //------ Upload Excel File ------
  const postFunction = async (file) => {
    if (file !== null && file !== undefined) {
      const body = new FormData();
      body.append("file", file[0]);

      return await axios.post(
        Config.AdminUploadApi,

        body,
        {
          headers: {
            authorization: user.token,
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      );
    } else throw Error("error");
  };

  const onSuccess = (data) => {
    //refetch();
    setOpenUploadModel(false);
  };

  const onError = (data) => {
    setOpenUploadModel(false);
  };

  const { isLoading: uploadLoading, mutate: uploadExcelFile } = useMutation(
    postFunction,
    { onSuccess, onError }
  );

  // ------ Delete device ------
  // const deleteDeviceHandler = async (id) =>
  const deleteDeviceHandler = async (values) => {
    const body = new FormData();
    body.append("id", values?.id);
    return await axios.post(
      // Config.DeleteDeviceApi,
      `${Config.apiUrl}/deletecustomer`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
      // { selectedData: id, status: 0 },
      // Config.AxiosConfig
    );
  };

  const onDeleteDeviceSuccess = (data) => {
    if (data?.data?.status == "OK") {
      getAppRegMutate(filter);

      setSelectedItem("");
      setOpenDeleteModel(false);
      // console.log("success", data);
      toast.success(data?.data?.msg || "Success");
    } else toast.error(data?.data?.msg || "Error");
  };

  const onDeleteDeviceError = (data) => {
    setOpenDeleteModel(false);
    setSelectedItem("");
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteDeviceLoading, mutate: deleteDeviceMutate } =
    useMutation(deleteDeviceHandler, {
      onSuccess: onDeleteDeviceSuccess,
      onError: onDeleteDeviceError,
    });

  //------- Add Single Entry -------
  const SingleEntryPostFunction = async (values) => {
    const body = new FormData();
    body.append("fName", values.fName);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("clubName", "National Sports Council of Tanzania");
    body.append("password", values.password);
    body.append("userType", values.type);
    return await axios.post(
      `${Config.apiUrl}/register`,
      body,
      Config.AxiosConfig
    );
  };

  const onSingleEntrySuccess = (data) => {
    //refetch();
    setSelectedData("");
    setOpenUploadModel(false);
  };

  const onSingleEntryError = (data) => {
    setOpenUploadModel(false);
    setSelectedData("");
  };

  const { isLoading: SingleEntryLoading, mutate: postSingleEntry } =
    useMutation(SingleEntryPostFunction, {
      onSuccess: onSingleEntrySuccess,
      onError: onSingleEntryError,
    });

  //------- Edit Single Entry -------
  const EditSingleEntryFunction = async (values) => {
    const body = new FormData();
    body.append("fName", values.fName);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    return await axios.post(`${Config.apiUrl}/editcustomer`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      //refetch();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    //refetch();
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editSingleEntry } = useMutation(
    EditSingleEntryFunction,
    {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    }
  );

  //Get HostNames Province api
  const getHostNamesFunction = async () =>
    await axios.get(Config.GetHostNamesandProvince, Config.AxiosConfig);

  const {
    data: hostNamesandProvince,
    error: hostNamesError,
    isLoading: hostNamesLoading,
  } = useQuery("GetHostNamesandProvince", getHostNamesFunction);
  // end of GetHostNamesandProvince api

  // change password
  const changePasswordFunction = async (values) => {
    const body = new FormData();
    //console.log(values);
    body.append("password", values.password);
    body.append("email", selectedData.email);
    //console.log( selectedData.email);
    body.append("confirmPassword", values.confirmPassword);
    return await axios.post(Config.apiUrl + "/changepasswordbyadmin", body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onChangePasswordSuccess = (data) => {
    toast.success(data?.data?.msg, "Success");
    setChangePasswordModel(false);
  };

  const onChangePasswordError = (data) => {
    toast.error(data?.response?.data?.msg, "An Error Occured");
  };

  const { mutate: changePasswordMutate, isLoading: changePasswordLoading } =
    useMutation(changePasswordFunction, {
      onSuccess: onChangePasswordSuccess,
      onError: onChangePasswordError,
    });

  const initialValues = {
    name: "",
    filterVal: "",
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    // startDate: moment(new Date()).subtract(7, "days").format("YYYY-MM-DD"),
    // endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    setFilterValue(values.filterVal);

    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getAppRegMutate();
  };

  return (
    <>
      <Navbar />
      {changePasswordModel && (
        <ChangePasswordModal
          setChangePasswordModel={setChangePasswordModel}
          changePasswordLoading={changePasswordLoading}
          changePasswordMutate={changePasswordMutate}
        />
      )}

      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Customers")}</Title>
              <Underline />
            </div>
          </div>
          {/* <BoxTitle onClick={() => navigate(-1)}>
            <img src={Images.Arrow} alt="arrow" className="w-2" />
            <p>Admin</p>
          </BoxTitle> */}
          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              filter={filter}
              user={user}
              t={t}
            />
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          {openDeleteModel && (
            <DeleteModel
              deleteDeviceLoading={deleteDeviceLoading}
              setOpenDeleteModel={setOpenDeleteModel}
              selectedData={selectedData}
              selectedItem={selectedItem}
              deleteDeviceMutate={deleteDeviceMutate}
              deviceId={selectedItem.id}
            />
          )}

          {/* {openUploadModel && (
          <UploadModel
            uploadLoading={uploadLoading}
            setOpenUploadModel={setOpenUploadModel}
            uploadExcelFile={uploadExcelFile}
            postSingleEntry={postSingleEntry}
            SingleEntryLoading={SingleEntryLoading}
          />
        )} */}
          {openUploadModel && (
            <SingleEntry
              postSingleEntry={postSingleEntry}
              SingleEntryLoading={SingleEntryLoading}
              setOpenUploadModel={setOpenUploadModel}
              hostNamesandProvince={hostNamesandProvince}
            />
          )}

          {editUser && (
            <EditUserModel
              editSingleEntry={editSingleEntry}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}
          {/* 
        {!isLoading && !isRefetching && (
          <TableWrapper>
            <AdminTable
              ApiData={error ? [] : data?.data}
              setOpenDeleteModel={setOpenDeleteModel}
              setSelectedData={setSelectedData}
              setEditUser={setEditUser}
            />
          </TableWrapper>
        )} */}

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setOpenDeleteModel={setOpenDeleteModel}
                setSelectedData={setSelectedData}
                setEditUser={setEditUser}
                setChangePasswordModel={setChangePasswordModel}
                setDeviceId={setDeviceId}
                setSelectedItem={setSelectedItem}
                // setSelectedCPDetails={setSelectedCPDetails}
              />
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  t,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">{t("Start_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">{t("End_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Date_filter")}
          </ApplyBtn>

          <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
            <Label htmlFor="filter">{t("Search")}</Label>

            <Select
              autoComplete="off"
              className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
              style={{ height: "40px" }}
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                //searchHandler(e.target.value);
              }}
            >
              <MenuItem value="name">By Name</MenuItem>
              <MenuItem value="phone">By Phone</MenuItem>
              {/* <MenuItem value="2">Pending Payments</MenuItem>
                <MenuItem value="3">InProgress</MenuItem>
                <MenuItem value="4">Approved By Asst</MenuItem>
                <MenuItem value="5">Completed</MenuItem>
                <MenuItem value="6">Certificate Issued</MenuItem>
                <MenuItem value="10">Rejected</MenuItem> */}
            </Select>
          </InputGroup>
          <InputGroup className="max-w-xs">
            <Label htmlFor="filterVal">{t("Value")}</Label>
            <FieldWrapper className="h-10">
              <Field
                type="text"
                name="filterVal"
                id="filterVal"
                class="ml-1"
                //  onSubmit={(e) => {
                //   setFilterValue(e.target.value);
                //   //searchHandler(e.target.value);
                // }}
              />
            </FieldWrapper>
          </InputGroup>

          {/* <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup> */}

          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Search")}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Add User</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

export default Customers;
